import { render, staticRenderFns } from "./StatusBadge.htm?vue&type=template&id=09d36784&scoped=true&"
import script from "./StatusBadge.ts?vue&type=script&lang=js&"
export * from "./StatusBadge.ts?vue&type=script&lang=js&"
import style0 from "./StatusBadge.scss?vue&type=style&index=0&id=09d36784&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d36784",
  null
  
)

export default component.exports